<template>
    <div>

        <section class="over">
            <div class="container">

                <div class="row">
                    <div class="col-md-6 text-center">
                        <img src="@/assets/images/main/sleep-outfitters-logo.png" style="max-width: 280px; padding-bottom: 30px;" class="header-image img-fluid" alt="Tempur-Pedic">
                    </div>
                    <div class="col-md-6 text-center">
                        <img src="@/assets/images/main/tempurpedic-logo.png" style="max-width: 280px; padding-bottom: 30px;" class="header-image img-fluid" alt="Tempur-Pedic">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p>Thank you for your interest in this program. The program has concluded.</p>
                        <p><a href="https://www.tempurpedic.com/" class="btn btn-blue btn-xs">Visit tempurpedic.com <i class="fa fa-long-arrow-right"></i></a></p>
                        <p><a href="https://www.sleepoutfitters.com/" class="btn btn-blue btn-xs">Visit sleepoutfitters.com <i class="fa fa-long-arrow-right"></i></a></p>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'over',
    mounted () {
    }
}
</script>

<style lang="scss" scoped>

    .over {
        margin-top: 50px;
        text-align: center;

        @media (min-width: 992px) {
            margin-top: 150px;
        }

        &__image {
            max-height: 150px;
            margin-bottom: 20px;
        }
    }

</style>
